<template>
  <div class="signIn">
    <div class="personal_loginRegister comWidth" v-if="logState">
      <div class="left_box ">
        <div class="login_box">
          <ul class="z_login_li">
            <li :class="{on:userState}" @click="userLogin">用戶登錄</li>
            <li :class="{on:telState}" @click="telLogin">手机動態登錄</li>
          </ul>
          <div class="z_login_table">

            <!--用户登录-->
              <div v-if="userState" class="form">
                <ul>
                  <li>
                    <input  v-model="telOne" name="username" type="tel" placeholder="請輸入註冊的手機帳號/郵箱" required>
                  </li>
                  <li>
                    <input v-model="passwordOne" type="password" placeholder="密碼" @keyup.enter="loginBtnOne" required>
                  </li>
                </ul>
                  <div>
                    <input value="1" name="remember" type="checkbox">&nbsp;&nbsp;&nbsp;30天內自動登錄
                  </div>
                <button @click="loginBtnOne" class="login_btn">登錄</button>
              </div>



            <!--手机动态登陆-->
              <div v-if="telState" class="z_pwd form" >
                <ul >
                  <li>
                    <label>手機號</label>
                    <input v-model="telTwo" type="tel" name="username" id="phone_username" placeholder="請輸入註冊的手機號碼">
                  </li>
                  <li class="fle">
                    <label >驗證碼</label>
                    <input v-model="captchaCode" type="text" placeholder="不區分大小寫" id="phone_captcha"  class="z_yzm">
                    <a class="jiaZai">
                      <img
                        :src="imgUrl"
                        v-if="ifImg"
                        alt="驗證碼"
                        width="100%"
                        id="imgcode"
                        @click="codeTab"/>
                      <span class="sIon" v-if="ifLod">
                        <i class="el-icon-loading" ></i>
                      </span>
                      <p @click="codeTab">看不清?</p>
                    </a>
                  </li>
                  <li>
                    <label>動態碼</label>
                    <input v-model="signCode" type="text" placeholder="動態碼" name="code_login" class="z_yzm" @keyup.enter="dynamicSignIn">
                    <div class="sendCodeBox lala" style="z-index: 1000">
                      <button class="to_havecode" v-if="toHavecodeOne" @click="dynamicCode" >點擊獲取</button>
                      <b v-if="codecountdownOne" class="Codecountdown">
                        <span ref="num">60</span>s获取
                      </b>
                    </div>
                  </li>
                </ul>
                <div>
                  <input value="1" name="remember" type="checkbox">30天內自動登錄
                </div>
                <button type="button" class="login_btn" @click="dynamicSignIn">登錄</button>
            </div>
          </div>
        </div>
      </div>
      <div class="right_box">
        <h5>創建帳戶</h5>
        <p>
          1分鐘創建帳戶並完善個人信息，即可享受：<br>
          <i></i>安全快捷支付訂單<br>
          <i></i>隨時跟蹤訂單狀態<br>
          <i></i>即時享受积分打折優惠及新品發布信息
        </p>
        <router-link :to="{name:'SignUp'}" tag="a">沒有登錄帳戶？立即創建一個吧！</router-link>
        <router-link :to="{name:'ForgetPassword'}" tag="a">忘記密碼</router-link>
      </div>
    </div>

    <!--导航-->
    <Nav :titles="titles" :titleChild="titleChild" :navState="navState" :tipsState="tipsState"/>
    <ProjectileFrame v-if="tipState"/>
  </div>
</template>

<script>
  import ProjectileFrame from '@/components/ProjectileFrame'
  import Nav from '@/components/Nav'
  //api
  import {signIn , signInCode , signInDynamic } from '@/api/signIn';
  import {getCaptcha} from '@/api/getCode';
  //md5
  import md5 from 'js-md5'
  import { getToken } from '@/utils/auts'
export default {
  name: 'SignIn',
  components:{
     Nav,
    ProjectileFrame
  },
  data () {
    return {
        /*导航*/
      tipsState:true,
      navState:false,
      titles: '請登錄',
      titleChild:[],
      //用户登录
      userState:true,
      telOne:'',
      passwordOne:'',
      //手机动态登陆
      telState:false,
      telTwo:'',
      captchaCode:'',
      signCode:'',
      /*点击获取验证码*/
      toHavecodeOne:true,
      codecountdownOne:false,
      //手机动态短信返回数据
      telCode:{
        key:'',
        code:'',
        expired_at:'',
      },
      //登录成功
      access_token:'',
      token_type:'',
      //登录成功提示
      logState:true,
      tipState:false,
      //手机正则验证
      telRg:/^1[3,4,5,6,7,8,9]\d{9}$/,
      /*Captcha*/
      imgUrl:'',
      captcha_key:'',
      captcha_code:'',

      isClick:true,

      // 是否显示加载提示
      ifImg:true,
      ifLod:false,
      count:0

    }
  },
  methods:{
      /*点击进入用户登录界面*/
    userLogin() {
      this.userState = true;
      this.telState = false;
    },
    /*点击进入手机动态登录界面*/
    telLogin() {
      this.userState = false;
      this.telState = true;
    },

    /*用户名登录*/
    loginBtnOne() {
        var telOne = (this.telOne).trim();
        var passwordOne = (this.passwordOne).trim();
        var obj = {
          username :　telOne,
          password :　passwordOne,
        };
        if(telOne === ''){
          this.$message.warning('用戶名不能為空');
        }else if (passwordOne === ''){
          this.$message.warning('密碼不能為空');
        }else if(passwordOne.length < 6){
          this.$message.warning('密碼錯誤');
        }else {
          signIn(obj).then(res =>{
            this.signInSuccess(res);
          })
        }
    },

    /*手机动态登录短信验证*/
    dynamicCode(){
//        if (this.isClick){
          if(!(this.telRg.test(this.telTwo))){
            this.$message.warning('請輸入正確的手機號');
          }else if(md5((this.captchaCode).trim()) != this.captcha_code){
            this.$message.warning('請輸入正確的動態驗證碼');
            this.getCaptchaCode()
          }else {
            var objData = {
              username:this.telTwo,
              captcha_key:this.captcha_key,
              captcha_code:this.captchaCode,
              action:'phone_login'
            };
            //发送验证
            signInCode(objData).then( (res) => {
   console.log(res);
      this.telCode = {
                key:res.data.key,
                code:res.data.code,
                expired_at:res.data.expired_at,
              };
              if(this.isClick){
                this.isClick = false;
                this.toHavecodeOne = false;
                this.codecountdownOne = true;
                var time_s = 60;
                var j = setInterval(() => {
                  time_s --;
                  //this.$refs.num.textContent = time_s;
                  if(time_s <= 0){
                    this.isClick = true;
                    this.toHavecodeOne = true;
                    this.codecountdownOne = false;
                    window.clearInterval(j);
                  }
                },1000);
              }
            }).catch(err =>{
              this.getCaptchaCode();
            })
      /*      this.toHavecodeOne = false;
            this.codecountdownOne = true;
            var time_s = 60;
            var j = setInterval(() => {
              time_s --;
              this.$refs.num.textContent = time_s;
              if(time_s <= 0){
                this.isClick = true;
                this.toHavecodeOne = true;
                this.codecountdownOne = false;
                window.clearInterval(j);
              }
            },1000);
            var objData = {
              username:this.telTwo,
              captcha_key:this.captcha_key,
              captcha_code:this.captchaCode,
              action:'phone_login'
            };
            //发送验证
            signInCode(objData).then( (res) => {
       console.log(res);
       this.telCode = {
                  key:res.data.key,
                  code:res.data.code,
                  expired_at:res.data.expired_at,
              };
            })*/

          }
//        }
    },

    /*手机动态登录*/
    dynamicSignIn(){
      if(!(this.telRg.test(this.telTwo))){
        this.$message.warning('請輸入正確的手機號');
      }else if(md5((this.captchaCode).trim()) != this.captcha_code){
        this.$message.warning('請輸入正確的動態驗證碼');
      }
      else if(md5((this.signCode).trim()) != this.telCode.code){
        this.$message.warning('請輸入正確的手機驗證碼');
      } else {
        var objData = {
          verification_key:this.telCode.key,
          verification_code:this.signCode,
        };
        signInDynamic(objData).then( (res) => {
           this.signInSuccess(res);
          this.isClick = false;
          this.toHavecodeOne = false;
          this.codecountdownOne = true;
        }).catch(err =>{
          this.getCaptchaCode()
        })
      }
    },


    /*获取动态验证码*/
    getCaptchaCode(){
      getCaptcha().then(res =>{
        this.imgUrl = res.data.captcha_image_content;
        this.captcha_key = res.data.captcha_key;
        this.captcha_code = res.data.code;
      }).catch(err =>{
        this.$message.warning('操作頻繁，請稍後再試')
      })
    },

    /*图形验证码切换*/
    codeTab(){
          this.ifImg = false
          this.ifLod = true
          this.getCaptchaCode()
          setTimeout(() => {
            this.ifImg = true
            this.ifLod = false
          }, 1000);
    },

    /*登录成功*/
    signInSuccess(res){
      this.$store.dispatch('SetToken',res.data.access_token).then(() => {}).catch(() => {});
      this.access_token = res.data.access_token;
      this.token_type = res.data.token_type;
      document.cookie = 'access_token='+ this.access_token;
      this.logState = false;
      this.tipState = true;
      this.titles =  '登錄成功';
      //登录5秒之后的默认页面跳转
      this.defaultPage();
    },

    /*判断登录状态*/
    ifSignIn(){
        if(!getToken()){
          this.logState = true;
          this.tipState = false;
          this.titles =  '請登錄';
        }else {
          this.logState = false;
          this.tipState = true;
          this.titles =  '登錄成功';
        }
    },

    /*登录5秒之后的默认页面跳转*/
    defaultPage(){
        setTimeout(()=>{
            if((/signIn/).test(window.location.href)){
              this.logState = false;
              this.tipState = false;
                this.$router.push({
                  name:'HomePage'
                })
            }
        },5000)
    }
  },

  mounted(){
    //获取动态验证码
    this.getCaptchaCode();
    //判断登录状态
    this.ifSignIn();
    window.scrollTo(0,0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../css/signIn.less";
</style>



// WEBPACK FOOTER //
// src/pages/login/SignIn.vue